import { useLocation, useNavigate } from "react-router-dom"
import { isDefined } from "../../../utils"

type FilterValue = string | string[]

export const useSetFilter = () => {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    filters: { filterName: string; filterValue?: FilterValue }[],
    urlOverride?: string,
  ) => {
    const queryParams = urlOverride
      ? new URLSearchParams()
      : new URLSearchParams(location.search)

    for (const filter of filters) {
      addFilterQueryParam(queryParams, filter.filterName, filter.filterValue)
    }

    // Remove page because we're setting a new filter
    queryParams.delete("page")

    navigate(
      `${urlOverride ?? location.pathname}${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
      {
        replace: true,
      },
    )
  }
}

const filtersQueryParam = "filters"

export const getFilterKey = (key: string) => `${filtersQueryParam}[${key}]`

const addFilterQueryParam = (
  queryParams: URLSearchParams,
  filterName: string,
  filterValue?: FilterValue,
) => {
  const key = getFilterKey(filterName)

  if (Array.isArray(filterValue)) {
    // Arrays are stored as repeated params: key=A&key=B
    queryParams.delete(key)
    for (const value of filterValue) {
      queryParams.append(key, value)
    }
  } else if (filterValue) {
    queryParams.set(key, filterValue)
  } else {
    queryParams.delete(key)
  }
  return queryParams
}

export const getFilterQueryParams = (queryParams: Record<string, unknown>) => {
  return Object.keys(queryParams)
    .filter((key) => isDefined(queryParams[key]))
    .map((key) => `${filtersQueryParam}%5B${key}%5D=${queryParams[key]}`)
    .join("&")
}
